import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { SKELETON_CLASSNAME, SKELETON_DUMMYTEXT } from '../../base/constants';
import ENV from '../../base/env';
import { EDomain } from '../../base/types';
import './SideStory.scss';
import stories from './stories.json';

interface SideStoryDef {
  title: string;
  image: string;
  description: string;
  link?: {
    [lang: string]: string;
  };
  linkLabel?: string;
}

interface SideStoryMap {
  [domainId: number]: SideStoryDef[];
}

interface IOwnProps {
  // current session domain id
  domain: EDomain | null;
}

const SideStory: React.FC<IOwnProps> = ({ domain }) => {
  const { t, language } = useTranslation();

  const loading = !domain;
  const skeletonClass = loading ? SKELETON_CLASSNAME : '';
  let title = SKELETON_DUMMYTEXT,
    image = '',
    description = SKELETON_DUMMYTEXT,
    link,
    linkLabel = '';

  if (!language) {
    return null;
  }

  if (!loading) {
    // get stories for given domain
    const domainStories = (stories as SideStoryMap)[domain];
    // choose story randomly
    const storiesAmount = domainStories.length;
    const storyNumber = Math.floor(Math.random() * storiesAmount);
    const story = domainStories[storyNumber];
    title = t(story.title);
    image = story.image;
    description = t(story.description);
    // if link and link label are set we render a link on the bottom
    if (story.link && story.linkLabel) {
      link = story.link[language] || story.link['de'];
      linkLabel = t(story.linkLabel);
    }
  }
  return (
    <div className="side-story">
      <h2 className={`side-story-title ${skeletonClass}`}>{title}</h2>
      <div className={`side-story-image-wrapper ${skeletonClass}`}>
        {!!image && (
          <img className="side-story-image" src={`${ENV.AssetsBaseUrl}/feature/side-story/${image}`} alt={title} />
        )}
      </div>
      <p className={`side-story-description ${skeletonClass}`}>{description}</p>
      {!!link && (
        <a className="side-story-cta" href={link}>
          {linkLabel}
        </a>
      )}
    </div>
  );
};

export default SideStory;
